var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from "../Model";
import { HorizonJs_Uuid } from "horizon-js-sdk/lib/HorizonJs_Uuid";
export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["PENDING"] = "PENDING";
    PaymentStatus["PAID"] = "PAID";
    PaymentStatus["CANCELED"] = "CANCELED";
    PaymentStatus["ERROR"] = "ERROR";
})(PaymentStatus || (PaymentStatus = {}));
export var PaymentResultCodeTranslation = {
    0: '',
    10: 'erreur inconnue',
    20: 'paiement expiré',
    30: 'paiement annulé par l\'acheteur',
    40: 'données invalides',
    41: 'numéro de carte invalide',
    42: 'possesseur de carte bancaire invalide',
    43: 'code de carte bancaire invalide',
    45: 'carte de crédit expirée',
    46: 'limites de la carte de crédit atteintes',
    50: 'DO_NOT_HONNOR',
    60: 'paiement refusé par la banque : nécessite plus d\'informations',
    70: 'paiement refusé par la banque : nécessite plus de données',
    80: 'paiement refusé par la banque',
    81: 'paiement refusé par la banque : limites du compte atteintes',
    82: 'paiement refusé par le terminal de paiement',
    90: 'paiement refusé : mode sécurisé incompatible',
    91: 'mode sécurisé expiré',
    92: 'mode sécurisé échoué',
    100: 'KYC insuffisant',
    110: 'erreur technique',
    111: 'erreur technique : erreur de token',
    200: 'tentative de fraude détectée',
    201: 'tentative de fraude détectée : carte perdue',
    202: 'tentative de fraude détectée : carte volée',
    203: 'tentative de fraude détectée : carte invalide',
    204: 'tentative de fraude détectée',
    205: 'tentative de fraude détectée : limites de paiement atteintes',
    206: 'tentative de fraude détectée : pays black listé',
    207: 'tentative de fraude détectée : compte bancaire temporairement bloqué',
    1000: 'erreur du prestataire de paiement',
};
var Payment = /** @class */ (function (_super) {
    __extends(Payment, _super);
    function Payment(obj) {
        if (obj === void 0) { obj = {}; }
        var _this = _super.call(this) || this;
        _this.uid = null;
        _this.paymentMethodUid = null;
        _this.fees = 0;
        _this.paymentStatus = PaymentStatus.PENDING;
        _this.rootPurchases = [];
        _this.invoicePublicHtmlUrl = null;
        _this.invoicePublicPdfUrl = null;
        if (typeof obj === 'string') {
            obj = JSON.parse(obj);
        }
        Payment.buildFromJson(_this, obj);
        return _this;
    }
    Payment.buildFromJson = function (instance, json) {
        if (json) {
            for (var prop in json) {
                if (json.hasOwnProperty(prop)) {
                    instance[prop] = json[prop];
                }
            }
        }
    };
    Payment.prototype.getResultCodeName = function () {
        var _a, _b;
        return (_b = PaymentResultCodeTranslation[(_a = this.paymentResultCode) !== null && _a !== void 0 ? _a : 10]) !== null && _b !== void 0 ? _b : 'erreur inconnue';
    };
    Payment.prototype.exportToJson = function () {
        var JSONPayment = {};
        JSONPayment.uid = this.uid;
        JSONPayment.orderUid = this.orderUid;
        JSONPayment.paymentMethodUid = this.paymentMethodUid;
        JSONPayment.amount = this.amount;
        JSONPayment.paymentResultCode = this.paymentResultCode;
        JSONPayment.paymentStatus = this.paymentStatus;
        JSONPayment.invoiceUid = this.invoiceUid;
        if (this.rootPurchases.length !== 0) {
            JSONPayment.rootPurchases = [];
            for (var _i = 0, _a = this.rootPurchases; _i < _a.length; _i++) {
                var item = _a[_i];
                JSONPayment.rootPurchases.push(item);
            }
        }
        return JSONPayment;
    };
    Payment.prototype.generateUid = function (allChilds) {
        if (allChilds === void 0) { allChilds = false; }
        if (this.uid === null) {
            this.uid = HorizonJs_Uuid.v4();
        }
    };
    return Payment;
}(Model));
export { Payment };
//# sourceMappingURL=Payment.js.map